export const filterListingImages = listing => {
  const programDetails = listing?.attributes?.publicData?.programDetails;
  const images = listing?.images || [];
  const programImageIds = new Set();

  if (programDetails?.details && Array.isArray(programDetails.details)) {
    programDetails.details.forEach(detail => {
      detail?.images?.forEach(uuid => programImageIds.add(uuid));
    });
  }

  return images.filter(
    image => image?.id?.uuid && !programImageIds.has(image.id.uuid)
  );
};

// The inverse of filterListingImages: the listing images that ARE referenced by the
// program/itinerary. Used to show a small visual teaser of the experience (these images
// are intentionally kept out of the main gallery, see filterListingImages).
export const getProgramImages = (listing, limit) => {
  const details = listing?.attributes?.publicData?.programDetails?.details;
  const images = listing?.images || [];

  if (!Array.isArray(details) || details.length === 0) {
    return [];
  }

  const programImageIds = new Set();
  details.forEach(detail => {
    detail?.images?.forEach(uuid => programImageIds.add(uuid));
  });

  const programImages = images.filter(
    image => image?.id?.uuid && programImageIds.has(image.id.uuid)
  );

  return typeof limit === 'number' ? programImages.slice(0, limit) : programImages;
};

export const getImageVariant = image => {
  if (
    image?.attributes?.variants &&
    'landscape-crop4x' in image.attributes.variants &&
    !('scaled-large' in image.attributes.variants)
  ) {
    return 'landscape-crop4x';
  }
  return 'scaled-large';
};

export const getImageUrl = (image, variant) => {
  const resolvedVariant = variant || getImageVariant(image);
  return image?.attributes?.variants?.[resolvedVariant]?.url || null;
};

export const getHeroImageUrl = images => {
  const first = images?.[0];
  if (!first) return null;
  const variants = first.attributes?.variants || {};
  return (
    variants['landscape-crop4x']?.url ||
    variants['scaled-xlarge']?.url ||
    variants['scaled-large']?.url ||
    null
  );
};

export const getHeroImageCaption = (image, listing) => {
  const variants = image?.attributes?.variants || {};
  const variantName =
    variants['landscape-crop4x']?.name ||
    variants['scaled-large']?.name ||
    variants['scaled-xlarge']?.name;

  if (variantName) {
    return variantName;
  }

  const location = listing?.attributes?.publicData?.location;
  const city = location?.city;
  const country = location?.country;

  if (city && country) {
    return `${city} — ${country}`;
  }

  return city || country || null;
};
